import {createAction} from '@packages/utilities/create-action';
import {CHECKLIST_STATE, ONBOARDING_SETTINGS_SOURCES} from './constants';

export const CONTEXTUAL_TUTORIAL_COMPLETE =
  'CONTEXTUAL_TUTORIAL_COMPLETE' as const;
export const CONTEXTUAL_ONBOARDING_EVENTS_FOUND =
  'CONTEXTUAL_ONBOARDING_EVENTS_FOUND' as const;
export const ONBOARDING_SETTINGS_EDITED = 'ONBOARDING_SETTINGS_EDITED' as const;
export const CONTEXTUAL_ONBOARDING_PROMPT_MANUALLY_TRIGGERED =
  'CONTEXTUAL_ONBOARDING_PROMPT_MANUALLY_TRIGGERED' as const;

export const actionTypes = {
  CONTEXTUAL_TUTORIAL_COMPLETE,
  CONTEXTUAL_ONBOARDING_EVENTS_FOUND,
  ONBOARDING_SETTINGS_EDITED,
  CONTEXTUAL_ONBOARDING_PROMPT_MANUALLY_TRIGGERED,
} as const;

/**
 * Util for when a contextual tutorial is completed and should be removed from the promptQueue
 */
export const onboardingTutorialCompleted = createAction(
  CONTEXTUAL_TUTORIAL_COMPLETE
);

/**
 * Util for when a user completes an action for which the user has event listeners
 */
export const onboardingEventsFound = createAction<
  typeof CONTEXTUAL_ONBOARDING_EVENTS_FOUND,
  {events: any[]}
>(CONTEXTUAL_ONBOARDING_EVENTS_FOUND);

export const onboardingSettingsEdited = createAction<
  typeof ONBOARDING_SETTINGS_EDITED,
  {
    settings:
      | {
          checklistState: (typeof CHECKLIST_STATE)[keyof typeof CHECKLIST_STATE];
        }
      | {
          aisgChecklistState: (typeof CHECKLIST_STATE)[keyof typeof CHECKLIST_STATE];
        }
      | {showQuickAddPrebuiltLayouts: boolean}
      | {showLayoutElementTour: boolean};
    source: (typeof ONBOARDING_SETTINGS_SOURCES)[keyof typeof ONBOARDING_SETTINGS_SOURCES];
    siteType?: 'aisg' | 'template' | 'blank';
  }
>(ONBOARDING_SETTINGS_EDITED);

export const promptManuallyTriggered = createAction<
  typeof CONTEXTUAL_ONBOARDING_PROMPT_MANUALLY_TRIGGERED,
  {triggerId: any}
>(CONTEXTUAL_ONBOARDING_PROMPT_MANUALLY_TRIGGERED);

export const actions = {
  onboardingTutorialCompleted,
  onboardingEventsFound,
  onboardingSettingsEdited,
  promptManuallyTriggered,
} as const;
